export default __webpack_public_path__ + "static/media/gallery-wip-emitter_10.0b1ae33f.jpg";